var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/suggested/plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cnv4wtadta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus",
    style: {
      clipPath: "url(#cnv4wtadta)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.414 2.969h1.172a.138.138 0 0 1 .156.156v13.75a.138.138 0 0 1-.156.156H9.414a.138.138 0 0 1-.156-.156V3.125a.138.138 0 0 1 .156-.156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M3.437 9.258h13.125a.138.138 0 0 1 .156.156v1.172a.138.138 0 0 1-.156.156H3.437a.138.138 0 0 1-.156-.156V9.414a.138.138 0 0 1 .156-.156z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.2aa56bc0aa7fec67aa4245627dcfa585.svg";
export { ForwardRef as ReactComponent };